import React from "react";
import dayjs from "dayjs";
import { classNames } from "utils";

import BlogPostTags from "./BlogPostTags";

import * as styles from "./BlogPostMetadata.module.less";

/**
 * @typedef {object} AdditionalProps
 * @prop {string} date
 * @prop {readonly string[]} tags
 *
 * @param {React.HTMLAttributes & AdditionalProps} param0
 */
export default function BlogPostMetadata({ date, tags, className }) {
  return (
    <div className={classNames(styles.metaData, className)}>
      <time dateTime={dayjs(date).format("YYYY-MM-DD HH:mm")}>
        {dayjs(date).format("MMMM DD, YYYY")}
      </time>

      {tags && (
        <>
          {" - "}
          <BlogPostTags tags={tags} />
        </>
      )}
    </div>
  );
}
